import { render, staticRenderFns } from "./DigiBoardsList.vue?vue&type=template&id=282050f6&scoped=true"
import script from "./DigiBoardsList.vue?vue&type=script&lang=js"
export * from "./DigiBoardsList.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardsList.vue?vue&type=style&index=0&id=282050f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282050f6",
  null
  
)

export default component.exports